import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const SideBar = styled.div`
  display: flex;
  flex: 1 1 15em;
  flex-direction: column;
  background-color: #08225f;
  color: white;
  @media screen and (max-width: 768px) {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    visibility: collapse;
    min-height: 60%;
    max-height: 80%;
    z-index: 1;
    &.active {
      visibility: visible;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1 1 calc(100% - 15em);
  padding: 1em;
  overflow: auto;
  box-shadow: inset rgb(0 0 0 / 6%) 0px 0px 8px 7px;
  background: #F0F5FF;
  @media screen and (max-width: 768px) {
    padding-bottom: 20px;
    display: block;
  }
`;
